var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrophyLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_61_345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33333 12.2167V13.5717C8.33019 13.8572 8.25374 14.1371 8.11132 14.3846C7.9689 14.6321 7.76528 14.8388 7.52 14.985C6.99929 15.3707 6.5757 15.8725 6.2829 16.4506C5.99011 17.0286 5.83617 17.667 5.83333 18.315",
    stroke: "var(--stroke-0, #14B8A6)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6667 12.2167V13.5717C11.6698 13.8572 11.7463 14.1371 11.8887 14.3846C12.0311 14.6321 12.2347 14.8388 12.48 14.985C13.0007 15.3707 13.4243 15.8725 13.7171 16.4506C14.0099 17.0286 14.1638 17.667 14.1667 18.315",
    stroke: "var(--stroke-0, #14B8A6)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 7.5H16.25C16.8025 7.5 17.3324 7.28051 17.7231 6.88981C18.1138 6.4991 18.3333 5.9692 18.3333 5.41667C18.3333 4.86413 18.1138 4.33423 17.7231 3.94353C17.3324 3.55283 16.8025 3.33333 16.25 3.33333H15",
    stroke: "var(--stroke-0, #14B8A6)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.33333 18.3333H16.6667",
    stroke: "var(--stroke-0, #14B8A6)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5 7.5C5 8.82608 5.52678 10.0979 6.46447 11.0355C7.40215 11.9732 8.67392 12.5 10 12.5C11.3261 12.5 12.5979 11.9732 13.5355 11.0355C14.4732 10.0979 15 8.82608 15 7.5V2.5C15 2.27899 14.9122 2.06702 14.7559 1.91074C14.5996 1.75446 14.3877 1.66667 14.1667 1.66667H5.83333C5.61232 1.66667 5.40036 1.75446 5.24408 1.91074C5.0878 2.06702 5 2.27899 5 2.5V7.5Z",
    stroke: "var(--stroke-0, #14B8A6)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5 7.5H3.75C3.19747 7.5 2.66756 7.28051 2.27686 6.88981C1.88616 6.4991 1.66667 5.9692 1.66667 5.41667C1.66667 4.86413 1.88616 4.33423 2.27686 3.94353C2.66756 3.55283 3.19747 3.33333 3.75 3.33333H5",
    stroke: "var(--stroke-0, #14B8A6)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrophyLeaderboard);
export default __webpack_public_path__ + "static/media/icon-trophy-leaderboard.c8d6adceda8f8bf9a0a2fca34b8c8f60.svg";
export { ForwardRef as ReactComponent };